import React from 'react'
import { HeadsetMic, Newspaper, OpenInNew, School } from '@mui/icons-material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import HeroConstellation from './decorations/HeroConstellation'
import smartpmLogo from '../../images/smartpm.png'

// The green call to action is the one link on this page that does not go to the
// public website: it opens the customer's private Service Hub (HU-03).
const SERVICE_HUB_URL = 'https://private.smartpm.es/'

/**
 * Landing hero: greets the user, states what the platform brings together and
 * offers the three highlighted resources plus the entry point to the Service Hub.
 *
 * @param {object} props
 * @param {string} props.greeting Already-resolved greeting line, e.g. "Good morning, Ada".
 */
const HeroSection = ({ greeting }) => {
  const { t_ } = useSmartTranslation()

  const highlights = [
    { id: 'academy', icon: <School />, label: t_('Academy and continuous training') },
    { id: 'support', icon: <HeadsetMic />, label: t_('Technical service and expert support') },
    { id: 'news', icon: <Newspaper />, label: t_('News from the industrial sector') }
  ]

  return (
    <section className='mic-home-hero'>
      <HeroConstellation />
      <img className='mic-home-hero-logo' src={smartpmLogo} alt='SMARTPM' />
      <div className='mic-home-hero-body'>
        <h1 className='mic-home-greeting'>{greeting}</h1>
        <p className='mic-home-lead'>
          {t_('Your projects, the support of our team and all your technical documentation, connected in a single platform.')}
        </p>
        <div className='mic-home-highlights'>
          {highlights.map((highlight) => (
            <div className='mic-home-highlight' key={highlight.id}>
              <span className='mic-home-highlight-icon'>{highlight.icon}</span>
              <span className='mic-home-highlight-label'>{highlight.label}</span>
            </div>
          ))}
          <a
            className='mic-home-cta mic-home-cta-solid'
            href={SERVICE_HUB_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t_('Enter MIC Service Hub')}
            <OpenInNew />
          </a>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
